export default __webpack_public_path__ + "static/media/no-profile-image.d38e67c0.svg";